var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-slide',[_c('article',{staticClass:"home",attrs:{"id":"start"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row full-height center-xs top-xs"},[_c('div',{staticClass:"col-xs-12 no-padding text-content"},[_c('img',{staticClass:"img-home",attrs:{"src":"static/RIBOCA_01_AD_HomepageBanner_750x1334_Art.png","alt":""}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd879b76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 